<template>
  <footer class="content-info">
    <div class="container">
      <p>estudio@jflorenzo.com<br>
      c/sta. teresa de jesús nº 17 5ºa 42003 soria<br>
      tf. <a href="tel:975 226 291">975 226 291</a><br>
      mv. <a href="tel:659 223 756">659 223 756</a></p>
    </div>
  </footer>
</template>

<script>
export default {

  name: 'Pie',

  data() {
    return {

    };
  },
};
</script>

<style lang="scss" scoped>
.content-info {
  letter-spacing: 1px;
  line-height: 1.2rem;
  // margin-top: calc(100% - 90vh);

  @media (min-width: 768px) {
    margin-top: 25px;
  }

  a {
    color: #666;
    text-decoration: none;
    transition: all 0.3s;
    &:hover {
      text-decoration: underline;
      color: inherit;
    }
  }

}
</style>
